import React from "react";
import { useAuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";

const Footer = () => {
  const { handleNotification, handleTCPP, handleTC } = useAuthContext();
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const scrollToHalf = () => {
    const halfPage = window.innerHeight / 2;
    window.scrollTo({ top: halfPage, behavior: 'smooth' });
  };

  return (
    <>
      {/** Large Screens */}
      <div className="w-full h-full bg-primaryColor pt-[3%] pb-[1%] px-[10%] hidden lg:block">
        <div className="w-full h-fit flex justify-between items-start mb-14">
          <div className="w-[45%] h-fit flex flex-col justify-start items-start space-y-4">
            <div className="w-full h-fit space-y-1">
              <img src="/assets/finelabs-logo-white.svg" alt="finelabs-logo" />
              <p className="font-normal text-xs text-whiteColor">
                India’s Best Lab Bazaar
              </p>
            </div> 
            <div className="w-full h-fit">
              <p className="font-light text-base text-whiteColor">
                Experience top-quality Medical Lab testing  in India
              </p>
              <p className="font-light text-base text-whiteColor">
                with Fine Labs, partnered with leading lab services
              </p>
              <p className="font-light text-base text-whiteColor">
                for reliable and accurate results.
              </p>
              <p className="font-light text-base text-whiteColor">
                Reserve your slot now!
              </p>
            </div>
          </div>
          <div className="w-[55%] h-fit flex justify-between items-start">
            <div className="flex flex-col">
              <span className="font-medium text-[20px] text-whiteColor mb-6">
                Our Partners
              </span>
              <Link to={"/labs/dr-lal-pathLabs"} className="font-normal text-base text-whiteColor mb-4">
                Dr Lal PathLabs
              </Link>
              <Link to={"/labs/pathkind-labs"} className="font-normal text-base text-whiteColor mb-4">
                Pathkind Labs
              </Link>
              <Link to={"/labs/redcliffe-labs"} className="font-normal text-base text-whiteColor mb-4">
                Redcliffe Labs
              </Link>
              <Link to={"/labs/agilus-diagnostics"} className="font-normal text-base text-whiteColor mb-4">
                Agilus Diagnostics
              </Link>
              <Link to={"/labs/metropolis-healthcare"} className="font-normal text-base text-whiteColor">
                Metropolis Healthcare
              </Link>
            </div>
            <div className="flex flex-col space-y-24">
              <div>
              <span className="font-medium text-[20px] text-whiteColor mb-6">
                Follow us
              </span>
              <div className="flex items-center space-x-4 mt-[10%]">
                <Link
                  to="https://www.linkedin.com/company/finelabsmarketplace/"
                  className="font-normal text-base text-whiteColor hover:underline"
                  title="https://www.linkedin.com/company/finelabsmarketplace/"
                >
                  <img src="/assets/linkedin-icon.svg" alt="linkedin-icon" />
                </Link>
                <Link
                  to="https://www.instagram.com/finelabsmarketplace?igsh=OHdzZXBpbG5sZm13&utm_source=qr"
                  className="font-normal text-base text-whiteColor hover:underline"
                  title="https://www.instagram.com/finelabsmarketplace?igsh=OHdzZXBpbG5sZm13&utm_source=qr"
                >
                  <img src="/assets/instagram-icon.svg" alt="instagram-icon" />
                </Link>
              </div>
              <div className="flex items-center space-x-4 mt-[10%]">
              <Link
                  to="https://www.facebook.com/share/1Bj832sqyw/"
                  className="font-normal text-base text-whiteColor hover:underline"
                  title="https://www.facebook.com/share/1Bj832sqyw/"
                >
                  <img src="/assets/facebook-icon.png" alt="instagram-icon" width={32} height={32}/>
                </Link>
                <Link
                  to="https://x.com/LabsFine12756?t=_0qQyAiOCxlD_bgUUDMwHQ&s=09"
                  className="font-normal text-base text-whiteColor hover:underline"
                  title="https://x.com/LabsFine12756?t=_0qQyAiOCxlD_bgUUDMwHQ&s=09"
                >
                  <img src="/assets/twitter-icon.png" alt="instagram-icon" width={32} height={32}/>
                </Link>
              </div>
              </div>
              <div className="flex flex-row items-center">
              <a
              href="https://wa.me/9138923900" 
              target="_blank" 
              rel="noopener noreferrer"  
              className="flex flex-row items-center"
            >
            <img src="/assets/whatsapp-icon.svg" alt="Whatsapp-icon" />
            <span className="ml-2 text-white">9138923900</span>
            </a>
              </div>
            </div>
            <div className="flex flex-col space-y-4">
              <Link
                to="/about-us"
                onClick={scrollToTop}
                className="font-normal text-base text-whiteColor hover:underline"
              >
                About us
              </Link>
              <Link
                to="/contact-us"
                onClick={scrollToTop}
                className="font-normal text-base text-whiteColor hover:underline"
              >
                Contact us
              </Link>
              <Link
                to="/contact-us"
                onClick={scrollToHalf}
                className="font-normal text-base text-whiteColor hover:underline"
              >
                FAQs
              </Link>
              <Link
              to="/blogs"
              onClick={scrollToTop}
              className="font-normal text-base text-whiteColor hover:underline"
            >
              Blogs
            </Link>
            </div>
          </div>
        </div>
        <hr />
        <p className="font-normal text-sm text-whiteColor text-center mt-4">
          2025 © Finelabs.in |{" "}
          <button className="hover:underline" onClick={handleTC}>
            Terms & Conditions
          </button>{" "}
          |{" "}
          <Link to="/privacy-policy" className="hover:underline">
            Privacy Policy
          </Link>{" "}
          |{" "}
           <Link to="https://www.lalpathlabs.com/privacy-policy" target="_blank" className="font-normal text-sm text-whiteColor hover:underline">
            Dr Lal PathLabs Privacy Policy
          </Link>
        </p>
      </div>

      {/** Small Screens */}
      <div className="w-full h-fit bg-primaryColor p-[7.5%] lg:hidden mb-[15%]">
        <div className="w-full h-fit flex justify-between items-center mb-[10%]">
          <div className="flex flex-col space-y-2">
            <img src="/assets/finelabs-logo-white.svg" alt="finelabs-logo" />
            <p className="font-normal text-[3.05vw] text-whiteColor">
              India’s Best Lab Bazaar
            </p>
          </div>
          <div className="flex flex-row items-center">
          <a
          href="https://wa.me/9138923900" 
          target="_blank" 
          rel="noopener noreferrer"  
          className="flex flex-row items-center"
        >
          <img src="/assets/whatsapp-icon.svg" alt="Whatsapp-icon" />
          <span className="ml-2 text-white">9138923900</span>
        </a>
          </div>
        </div>
        <div className="w-full h-fit flex justify-between items-start mb-[10%]">
          <div className="flex flex-col">
            <span className="font-medium text-[5vw] text-whiteColor mb-[15%]">
              Our Partners
            </span>
            <Link to={"/labs/dr-lal-pathLabs"} className="font-normal text-base text-whiteColor mb-4">
                Dr Lal PathLabs
            </Link>
           <Link to={"/labs/pathkind-labs"} className="font-normal text-base text-whiteColor mb-4">
              Pathkind Labs
            </Link>
            <Link to={"/labs/redcliffe-labs"} className="font-normal text-base text-whiteColor mb-4">
              Redcliffe Labs
            </Link>
            <Link to={"/labs/agilus-diagnostics"} className="font-normal text-base text-whiteColor mb-4">
              Agilus Diagnostics
            </Link>
            <Link to={"/labs/metropolis-healthcare"} className="font-normal text-base text-whiteColor">
              Metropolis Healthcare
            </Link>
          </div>
          <div className="flex flex-col">
            <span className="font-medium text-[5vw] text-whiteColor mb-[25%]">
              Follow us
            </span>
            <div className="flex items-center space-x-4 mb-[20%]">
              <Link
                to="https://www.linkedin.com/company/finelabsmarketplace/"
                className="font-normal text-base text-whiteColor hover:underline"
                title="https://www.linkedin.com/company/finelabsmarketplace/"
              >
                <img src="/assets/linkedin-icon.svg" alt="linkedin-icon" />
              </Link>
              <Link
                to="https://www.instagram.com/finelabsmarketplace?igsh=OHdzZXBpbG5sZm13&utm_source=qr"
                className="font-normal text-base text-whiteColor hover:underline"
                title="https://www.instagram.com/finelabsmarketplace?igsh=OHdzZXBpbG5sZm13&utm_source=qr"
              >
                <img src="/assets/instagram-icon.svg" alt="instagram-icon" />
              </Link>
            </div>
            <div className="flex items-center space-x-4 mb-[25%]">
              <Link
                  to="https://www.facebook.com/share/1Bj832sqyw/"
                  className="font-normal text-base text-whiteColor hover:underline"
                  title="https://www.facebook.com/share/1Bj832sqyw/"
                >
                  <img src="/assets/facebook-icon.png" alt="instagram-icon" width={32} height={32}/>
                </Link>
                <Link
                  to="https://x.com/LabsFine12756?t=_0qQyAiOCxlD_bgUUDMwHQ&s=09"
                  className="font-normal text-base text-whiteColor hover:underline"
                  title="https://x.com/LabsFine12756?t=_0qQyAiOCxlD_bgUUDMwHQ&s=09"
                >
                  <img src="/assets/twitter-icon.png" alt="instagram-icon" width={32} height={32}/>
                </Link>
              </div>
            <Link
              to="/about-us"
              onClick={scrollToTop}
              className="font-normal text-[4vw] text-whiteColor hover:underline mb-[25%]"
            >
              About us
            </Link>
            <Link
              to="/contact-us"
              onClick={scrollToTop}
              className="font-normal text-[4vw] text-whiteColor hover:underline mb-[25%]"
            >
              Contact us
            </Link>
            <Link
              to="/contact-us"
              onClick={scrollToHalf}
              className="font-normal text-[4vw] text-whiteColor hover:underline mb-[25%]"
            >
              FAQs
            </Link>
            <Link
              to="/blogs"
              onClick={scrollToHalf}
              className="font-normal text-[4vw] text-whiteColor hover:underline"
            >
              Blogs
            </Link>
          </div>
        </div>
        <hr />
        <p className="font-normal text-[3.5vw] text-whiteColor text-center mt-[5%]">
          2025 © Finelabs.in
        </p>
        <div className="w-full h-fit flex justify-center items-center space-x-2 mt-[2%]">
          <button
            className="font-normal text-[3vw] text-whiteColor"
            onClick={handleTC}
          >
            | Terms & Conditions
          </button>
          <span className="font-normal text-[3vw] text-whiteColor">|</span>
          <Link to="/privacy-policy" className="font-normal text-[3vw] text-whiteColor">
            Our Privacy Policy  | 
          </Link>
        </div>
          <Link to="https://www.lalpathlabs.com/privacy-policy" target="_blank" className="font-normal text-[3vw] text-whiteColor flex justify-center mt-[2%]">
            Dr Lal PathLabs Privacy Policy
          </Link>
      </div>
    </>
  );
};

export default Footer;
